import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Card } from "../components/ui/card";

function fmt(iso) { return iso ? new Date(iso).toLocaleString() : ""; }

export default function Receipts() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.listReceipts().then(setItems); }, []);
  return (
    <div className="space-y-6" data-testid="receipts-page">
      <header>
        <div className="text-[11px] tracking-eyebrow text-muted-foreground">Committee view</div>
        <h1 className="text-3xl sm:text-4xl tracking-tight font-medium mt-2">Evidence receipts</h1>
        <p className="text-sm text-muted-foreground mt-2">Every governance decision the club takes is receipted with a unique ID, a hash, and a timestamped trail.</p>
      </header>
      {items.length === 0 && (
        <Card className="p-6 text-sm text-muted-foreground">No receipts yet. Resolve exceptions on an event or close an incident to generate one.</Card>
      )}
      <div className="space-y-2">
        {items.map((r) => (
          <Link key={r.id} to={`/receipts/${r.id}`} className="block" data-testid={`receipt-row-${r.id}`}>
            <Card className="p-4 border-border hover:shadow-md transition-shadow flex items-center justify-between gap-3">
              <div className="font-mono-ui">
                <div className="text-sm">{r.id}</div>
                <div className="text-xs text-muted-foreground">{fmt(r.created_at)} · hash {r.hash}</div>
              </div>
              <div className="text-xs text-muted-foreground">
                {r.event_id ? `Event · ${r.event_id}` : r.incident_id ? `Incident · ${r.incident_id}` : ""}
              </div>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
